module.exports = __webpack_public_path__ + "static/img/banner2.9288dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/banner2.jpg
// module id = 4Lrk
// module chunks = 1